


































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import HomeIcons from '@/components/home/swiperIcons.vue'
import activeList from '@/components/home/activeList.vue'
import tabBar from '@/components/home/manageBar.vue'

const activityManagementModule = namespace('activityManagement')
@Component({
  components: {
    HomeIcons,
    activeList,
    tabBar
  }
})
export default class Home extends Vue {
  finished: boolean = false
  loading: boolean = false
  activityListPageLoading!: boolean
  topIcon: any = {
    list: [],
    num: 4
  }
  classIcon: any = {
    list: [],
    num: 4
  }
  pages: any = {
    pageNum: 1,
    pageSize: 50,
    totalPage: 0
  }
  activeList: any = []
  tabActive: number = 0
  filterPath() {
    return this.topIcon.list.filter(
      (item: any) => this.$global.routes.indexOf(item.path) >= 0
    )
  }
  mounted() {
    this.topIcon.list = [
      {
        path: '/coupon/audit',
        imgUrl: require('../image/icon_1.png'),
        desc: '券管理'
      }
    ]
    this.topIcon.list.filter(
      (item: any) => this.$global.routes.indexOf(item) >= 0
    )
    this.classIcon.list = [
      {
        imgUrl: require('../image/icon_7.png'),
        path: '/reviewSales',
        desc: '上报销售',
        msg: '上报销售(商管端)'
      },
      {
        imgUrl: require('../image/icon_8.png'),
        path: '/estateManage',
        desc: '物业报修',
        msg: '物业报修(商管端)'
      }
    ]
    this.topIcon.list = this.filterPath()
    console.log(this.topIcon.list)
    this.getActivityList()
  }
  getActivityList() {
    this.$store
      .dispatch('activityManagement/getActivityList', {
        pageNum: 1,
        pageSize: 5,
        isUsable: 1
      })
      .then(res => {
        if (res.success) {
          this.activeList = res.success.data.list
          this.activeList.map((item: any) => {
            let _item = item
            _item.activityStartDate = this.$format(
              _item.activityStartDate,
              'YYYY.MM.DD'
            )
            _item.activityEndDate = this.$format(
              _item.activityEndDate,
              'YYYY.MM.DD'
            )
            return _item
          })
        }
      })
  }
}
